import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page">
      <header className="privacy-policy-hero">
        <div className="privacy-policy-container">
          <a className="privacy-policy-brand" href="/">
            DataDos
          </a>
          <p className="privacy-policy-kicker">Información legal</p>
          <h1>Política de Privacidad</h1>
          <p>
            En esta página te explico cómo se tratan los datos personales que envías a través de los formularios de DataDos.
          </p>
        </div>
      </header>

      <main className="privacy-policy-main">
        <div className="privacy-policy-container privacy-policy-content">
          <section>
            <h2>Responsable del tratamiento</h2>
            <p>
              El responsable del tratamiento de los datos personales recogidos en este sitio web es Julio Humberto Márquez Vacaflor.
            </p>
            <ul>
              <li><strong>NIF:</strong> 55309561N</li>
              <li><strong>Domicilio:</strong> Calle Francisco Gourié, 107, edificio Dunas, 2da planta, oficina 5, CP 35003, Las Palmas, Las Palmas de GC</li>
              <li><strong>Email:</strong> <a href="mailto:info@datados.es">info@datados.es</a></li>
            </ul>
          </section>

          <section>
            <h2>Finalidad del tratamiento</h2>
            <p>
              Los datos que facilitas se utilizan para responder a tus solicitudes de información, valorar tu caso, contactar contigo y gestionar la relación profesional que pueda derivarse de tu consulta.
            </p>
          </section>

          <section>
            <h2>Legitimación</h2>
            <p>
              La base legal para tratar tus datos es tu consentimiento al enviar el formulario y, cuando corresponda, la aplicación de medidas precontractuales solicitadas por ti.
            </p>
          </section>

          <section>
            <h2>Conservación de los datos</h2>
            <p>
              Los datos se conservarán durante el tiempo necesario para atender tu solicitud y, posteriormente, durante los plazos legales exigibles si existiera una relación profesional o una obligación normativa.
            </p>
          </section>

          <section>
            <h2>Destinatarios</h2>
            <p>
              No se cederán tus datos a terceros salvo obligación legal o cuando sea necesario para prestar un servicio solicitado, siempre con las garantías legales correspondientes.
            </p>
          </section>

          <section>
            <h2>Derechos</h2>
            <p>
              Puedes ejercer tus derechos de acceso, rectificación, supresión, oposición, limitación y portabilidad escribiendo a <a href="mailto:info@datados.es">info@datados.es</a>.
            </p>
          </section>

          <section>
            <h2>Seguridad</h2>
            <p>
              DataDos aplica medidas técnicas y organizativas razonables para proteger la información personal frente a pérdida, acceso no autorizado o uso indebido.
            </p>
          </section>

          <div className="privacy-policy-actions">
            <a className="privacy-policy-button" href="/auditoria-ecommerce">
              Volver a la auditoría ecommerce
            </a>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PrivacyPolicy;
